<template>
    <div>
        <view-item v-if="!!template" :template_id="template.id" @success="alertSuccess" @delete-item="deleteType"
            @cancel="template = null"></view-item>

        <list-items v-else :title="$translate('templates')" @show-item="evt => showTemplate(evt)" ref="table">

    <div
        class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button"
      >
        <b-button
          id="add-template-btn"
          variant="blue-icon"
          v-b-tooltip.hover
          :title="$addLabel()"
          v-if="hasPermissionCreate"
          @click="showTemplate()"
        >
          <img src="@/assets/images/icon/gradient-add.svg" />
        </b-button>

        <b-button
          id="import-template-btn"
          variant="blue-icon"
          v-b-tooltip.hover
          :title="$translate('import')"
          @click="importModal = true"
          v-if="hasPermissionCreate"
        >
          <img src="@/assets/images/icon/import.svg" />
        </b-button>

        
    </div>
            
        </list-items>

        <b-modal
            v-model="importModal"
            hide-footer
            size="sm"
            no-close-on-backdrop
            class="pt-8"
            centered
            header-class="p-0"
            body-class="p-2"
            footer-class="d-flex justify-content-center border-0"
            content-class="custom-model-wrap"
            >
            <template #modal-title>
                <div class="title-block text-center p-2">
                {{ $translate("import") }}
                </div>
            </template>
            <import-orders-template-form
                @success="importModal = false"
                @cancel="importModal = false"
            />
        </b-modal>

        <!-- <import-form
        :subject="$translate('templates')"
        v-model="importModal"
        @cancel="hideModal()"
        :fields="inventoryFields"
        :upload-record="uploadInventoryRecord"
        settings-key-name="templateUploadKey"
      ></import-form> -->
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import importMixins from "@/mixins/importMixins";
import showItemHelper from "@/mixins/showItemHelper";

import ListItems from './ListItems'
import ViewItem from './ViewItem'
// import ImportForm from "@/components/ImportForm.vue";
import ImportOrdersTemplateForm from "./ImportOrdersTemplateForm";

const inventoryFields = [
  { name: "order_category", label: "category", required: true, type: "text" },
  { name: "name", label: "name", required: true, type: "text" },
  {
    name: "description",
    label: "description",
    required: false,
    type: "text",
  },
  {
    name: "order_type",
    label: "primary_type",
    required: true,
    type: "text",
  },
  {
    name: "secondary_order_type",
    label: "secondary_type",
    required: false,
    type: "text",
  },
];

export default {
    name: 'activityTemplates',
    components: {
        ListItems,
        ViewItem,
        // ImportForm,
        ImportOrdersTemplateForm,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins, importMixins, showItemHelper],
    data: () => {
        return {
            template: null,
            importModal: false,
            loading: false,
            inventoryFields,
        }
    },
    created() {
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('orderCategory/fetchAll')
        this.$store.dispatch('transactionType/fetchAll')
    },
    mounted() {
        // this.doSearch()
    },
    computed: {
        componentName() { return this.$translate('activity_template') },
        templates() {
            const templates = this.$store.state.orderTemplate.templates
            console.log('templates', templates)
            return templates
        },
        categories() {
            const categories = this.$store.state.orderCategory.categories
            console.log('categories', categories)
            return categories
        },
        types() {
            const items = this.$store.state.orderType.items
            console.log('items', items)
            return items
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
       async doSearch() {
           await this.$store.dispatch('orderTemplate/fetchAll')
        },

        async showTemplate(id) {
            if (id) {
                this.template = this.templates.find(x => x.id === id)
              await this.$store.dispatch('orderTemplate/fetchById', id)
            } else {
                const newItem = {
                    id: null,
                    order_category_id: null,
                    name: null,
                    description: null,
                    order_type_id: null,
                    secondary_order_type_id: null,
                    items: [],
                }
                this.template = newItem
                this.$store.commit('orderTemplate/set_template', newItem)
            }
        },

        alertSuccess(action, name, message) {
            this.genericToast(this.componentName, this.$translate(`${action}d`), 'success', `"${name}" ${message}`)
            if(action != 'create') {
                this.template = null
                this.doSearch()
            }
        },

        async uploadInventoryRecord(
            dataRecord,
            statusRecord,
            { check, message, field },
            statuses,
            setLoading
        ) {
            try {
                let {
                    order_category,
                    name,
                    description,
                    order_type,
                    secondary_order_type,
                } = dataRecord;

                statusRecord.status = statuses.CHECKING;
                console.log("field", field);

                if (check != 1) throw new Error(`${this.$translate(field)}-${message}`);

                order_category = order_category || "";
                order_category = order_category.trim();
                const order_category_id = this.getCustomEntityId(
                    order_category,
                    this.categories,
                    "name",
                    "Category"
                );

                order_type = order_type || "";
                order_type = order_type.trim();
                const order_type_id = this.getCustomEntityId(
                    order_type,
                    this.types,
                    "name",
                    "Primary Type"
                );

                secondary_order_type = secondary_order_type || "";
                secondary_order_type = secondary_order_type.trim();
                const secondary_order_type_id = secondary_order_type != '' && this.getCustomEntityId(
                    secondary_order_type,
                    this.types,
                    "name",
                    "Secondary Type"
                );

                const param = {
                    order_category_id,
                    name,
                    description,
                    order_type_id,
                    secondary_order_type_id: secondary_order_type_id > 0 ? secondary_order_type_id : null,
                };
                console.log({ param });

                const res = await this.$store.dispatch("orderTemplate/create", param);
                console.log("response:", res);
                // set status to complete if the upload was successful
                statusRecord.status = statuses.COMPLETE;

                this.doSearch()
            } catch (err) {
                console.error("err", err);
                statusRecord.error_list =
                typeof err.message == "string"
                    ? [["error", [err.message]]]
                    : Object.entries(err.message);
                statusRecord.status = statuses.ERROR;
            } finally {
                setLoading(false);
            }
            },
    },
}
</script>
<style></style>
